import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import {CallerAPI, InviteCallerAPI, DeleteCallerAPI} from "./../../API/Team/CallerAPI";
import Sidebar from "./Common/Sidebar";
import Header from "./Common/Header";
import InvitationModal from "./InvitationModal";
import Loader from "./../Loader";
import Paginate from "./../../utils/Pagination";
import DeleteConfirmPopup from "./../../utils/DeleteConfirmPopup";


const Callers = () =>{

    const [callers, setCallers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [showPopup, setShowPopup] = useState(false);
    const [email, setEmail] = useState("");
    const [showdeletepopup, setShowDeletePopup] = useState(false);
    const [headertext, setHeaderText] = useState("Delete this caller?");
    const [deletepopupcontent, setDeletePopupContent] = useState("Are you sure to delete this caller?");
    const [deletecallerid, setDeleteCallerID] = useState(null);
    const [iscallerdelete, setIsCallerDelete] = useState(false);
    const [iscalleradd, setIsCallerAdd] = useState(false);
    const [showinvitespinner, setShowInviteSpinner] = useState(false);
    const [showdeletespinner, setShowDeleteSpinner] = useState(false);
    
    const perpagedata = 15;


    useEffect(() => {

        CallerAPI(setCallers, setLoading, currentPage, perpagedata, setPageCount);

        //console.log('>>>>'+usersList);

    }, [currentPage, iscallerdelete, iscalleradd]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    const handlePopToggle = () =>{
        setShowPopup(!showPopup);
    }

    const handlePopupClose = () =>{
        setShowPopup(false);
    }

    const handleInputEmail = (event) =>{

        setEmail(event.target.value);
    }

    const handleCallerInvite = () =>{

        console.log('Submit email===' + email);

        const params = {
                        "email": email
                    }

        InviteCallerAPI(params, setIsCallerAdd, setShowPopup, setShowInviteSpinner);
    }

    const handleButtonCancel = () =>{
        setShowDeletePopup(false);
    }
    
    const handleButtonDelete = (e) =>{
        //event.preventDefault();

        console.log('deleted caller id===='+deletecallerid);

        /*const params = {
                        "callerid": deletecallerid
                    };*/
        if(deletecallerid > 0)
        {
            DeleteCallerAPI(deletecallerid, setIsCallerDelete, setShowDeletePopup, setShowDeleteSpinner);
        }
        
    }

    const handleDeleteCallerPopup = (callerid) =>{
        setShowDeletePopup(!showdeletepopup);

        setDeleteCallerID(callerid);
    }


    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

                <div className="row">
                    <div className="col-md-12">

                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h4 className="page-title">Callers</h4>
                                </div>
                                <div className="col-4 text-end">
                                    <div className="">
                                        <button type="button" className="btn btn-primary" onClick={handlePopToggle}>
                                            <i className="ti ti-square-rounded-plus me-2"></i>Invite
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card">                            
                            <div className="card-body">
                                <div className="d-flex align-items-center justify-content-between flex-wrap">
                                    <div className="dropdown">
                                        
                                    </div>
                                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                                        
                                    </div>
                                </div>

                                <div className="table-responsive custom-table">
                                    <table className="table" id="faqlist">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>ID</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Last Seen</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {loading ?
                                            <tr>
                                                <td colSpan="6">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            (callers && callers.length > 0  ? 
                                                ( callers.map(caller => 
                                                    (
                                            
                                                        <tr key={caller.id}>
                                                            <td>{caller.id}</td>
                                                            <td>{caller.name ? caller.name : "-"}</td>
                                                            <td>{caller.email}</td>
                                                            <td>
                                                                { caller.last_login_date ?
                                                                    (moment(caller.last_login_date).format('DD-MM-YYYY'))
                                                                :
                                                                    <p>-</p>
                                                                }
                                                            </td>
                                                            <td>
                                                                { caller.is_invitation_sent == 1 ?
                                                                    <span class="badge badge-pill badge-status bg-warning">Pending</span>
                                                                :
                                                                    (caller.is_invitation_sent == 2 ?
                                                                        <span class="badge badge-pill badge-status bg-success">Active</span>
                                                                    :
                                                                        <span class="badge badge-pill badge-status bg-danger">Inactive</span>
                                                                    )
                                                                }
                                                            </td>
                                                            <td>
                                                                <button type="button" class="btn btn-danger btn-sm" onClick={()=> handleDeleteCallerPopup(caller.id)}>
                                                                    <i className="ti ti-trash"></i> Delete
                                                                </button>	
                                                                									
                                                            </td>
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="6">
                                                        <p>No record found...</p>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                    
                                </div>
                                

                            </div>
                        </div>
                        
                        {pagecount > 1 ?
                        <div className="row pagination-section">

                            <nav>
                                <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                            </nav>
                        </div>
                        :
                            <></>
                        }

                    </div>
                </div>
                
                <InvitationModal toggleShow={showPopup} btnClose={handlePopupClose} btnCallerInvite={handleCallerInvite} inputEmail={handleInputEmail} txtemail={email} btninvitespin={showinvitespinner} />

                <DeleteConfirmPopup toggleDeleteShow={showdeletepopup} btnCancel={handleButtonCancel} btnDelete={handleButtonDelete} txtModalHeader={headertext} txtModalContent={deletepopupcontent} btndeletespin={showdeletespinner} />
                
            </div>
        </div>

    </div>
    )
}

export default Callers;